import { useMemo } from 'react';
import { FieldPath, FieldValues } from 'react-hook-form';
import { FormSelect, FormSelectProps } from '../common/form';
import { SystemClassifierCode } from '../systemClassifier';
import {
  SystemClassifierOption,
  useSystemClassifierSelectOptions,
} from './useSystemClassifierSelectOptions';

export interface SystemClassifierFormSelectProps<
  FormData extends FieldValues,
  Name extends FieldPath<FormData> = FieldPath<FormData>,
  Value extends FormData[Name] = FormData[Name],
> extends FormSelectProps<FormData, Name, Value> {
  code: SystemClassifierCode;
  filterFn?: (option: SystemClassifierOption) => boolean;
}

export const SystemClassifierFormSelect = <
  FormData extends FieldValues,
  Name extends FieldPath<FormData> = FieldPath<FormData>,
  Value extends FormData[Name] = FormData[Name],
>(
  props: SystemClassifierFormSelectProps<FormData, Name, Value>,
) => {
  const { code, filterFn, ...rest } = props;
  const systemClassifierSelectOptions = useSystemClassifierSelectOptions([
    code,
  ])[code];

  const options = useMemo(
    () =>
      (systemClassifierSelectOptions || []).filter((option) =>
        filterFn ? filterFn(option) : true,
      ),
    [filterFn, systemClassifierSelectOptions],
  );

  return <FormSelect options={options} {...rest} />;
};
